import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "fill-height d-flex selection-page-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "info-container"
}
const _hoisted_3 = { class: "ml-4" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "d-flex justify-space-between mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_timeseries_control_panel = _resolveComponent("timeseries-control-panel")!
  const _component_grid_control_panel = _resolveComponent("grid-control-panel")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_timeseries_map = _resolveComponent("timeseries-map")!
  const _component_grid_map = _resolveComponent("grid-map")!
  const _directive_show_important = _resolveDirective("show-important")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "control mr-2 pa-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex justify-end align-center", [_ctx.showHint ? 'mb-6' : '']])
        }, [
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (_ctx.showHint)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_icon, { color: "primary" }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" mdi-alert-circle-outline ", -1)
                      ]))]),
                      _: 1
                    }),
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeseriesText, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          (item.type === 'icon')
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                                key: 0,
                                class: "inline-block ml-1"
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.content), 1))
                        ]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.rasterType === _ctx.RasterType.TIMESERIES]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridText, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          (item.type === 'br')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_6))
                            : (item.type === 'icon')
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                                  key: 1,
                                  class: "inline-block ml-1"
                                }))
                              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.content), 1))
                        ]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.rasterType === _ctx.RasterType.GRID]
                    ]),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      size: "32",
                      variant: "text",
                      onClick: _ctx.removeHint
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { color: "scrim" }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" mdi-close-circle ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_v_btn_toggle, {
            modelValue: _ctx.rasterType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rasterType) = $event)),
            density: "compact",
            mandatory: "",
            color: "primary",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tooltip, {
                text: _ctx.t('raster.tooltip.switch_mode_to_timeseries'),
                bottom: "",
                "open-delay": 200
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    "data-testid": "timeseries-mode",
                    variant: "outlined"
                  }), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('timeseries')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 8, ["text"]),
              _createVNode(_component_v_tooltip, {
                text: _ctx.t('raster.tooltip.switch_mode_to_bounding_box'),
                bottom: "",
                "open-delay": 200,
                style: {"z-index":"99999"}
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    "data-testid": "raster-mode",
                    variant: "outlined"
                  }), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('bounding_box')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _withDirectives(_createVNode(_component_timeseries_control_panel, null, null, 512), [
          [_directive_show_important, _ctx.rasterType === _ctx.RasterType.TIMESERIES]
        ]),
        _withDirectives(_createVNode(_component_grid_control_panel, null, null, 512), [
          [_directive_show_important, _ctx.rasterType === _ctx.RasterType.GRID]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, { class: "ml-2 map" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_timeseries_map, {
          key: 'timeseries-' + _ctx.rasterType,
          "data-testid": "timeseries-map",
          class: "full-height-width",
          visible: _ctx.rasterType === _ctx.RasterType.TIMESERIES
        }, null, 8, ["visible"])), [
          [_vShow, _ctx.rasterType === _ctx.RasterType.TIMESERIES]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_grid_map, {
          key: 'grid-' + _ctx.rasterType,
          "data-testid": "grid-map",
          class: "full-height-width",
          visible: _ctx.rasterType === _ctx.RasterType.GRID
        }, null, 8, ["visible"])), [
          [_vShow, _ctx.rasterType === _ctx.RasterType.GRID]
        ])
      ]),
      _: 1
    })
  ]))
}